import React from 'react';
import AIRecommendationArchiveViewer from '@/components/admin/AIRecommendationArchiveViewer';

const AIArchivePage: React.FC = () => {
  return (
    <div className="container mx-auto py-6">
      <AIRecommendationArchiveViewer />
    </div>
  );
};

export default AIArchivePage; 